"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const clickHandlerMapping = {
  onClick: 'onPress',
  onMouseDown: 'onPressIn',
  onMouseUp: 'onPressOut'
};
var _default = exports.default = {
  /**
   * Web-oriented HTML click handlers that may be mapped to React Native press handlers
   */
  types: Object.fromEntries(Object.keys(clickHandlerMapping).map(mouseName => [mouseName, _propTypes.default.func])),
  /**
   * Takes a set of props and converts HTML mouse click oriented event handlers to closest
   * equivalent React Native press event handler.
   *
   * Use this when a component that expects press-oriented props may need to support third-party
   * web-oriented tooling that injects web-oriented event handlers directly. For example, for
   * to support use with NextJS's 'next/link' component, which injects `onClick` prop into its child.
   */
  toPressProps: props => Object.fromEntries(Object.entries(props).map(_ref => {
    let [originalName, value] = _ref;
    const translatedName = clickHandlerMapping[originalName];
    return translatedName ? [translatedName, value] : [originalName, value];
  }))
};